"use strict";
exports.__esModule = true;
var DarkModeHandler = /** @class */ (function () {
    function DarkModeHandler() {
        var _this = this;
        this.isNode = false;
        this.state = 'light';
        this.subscribers = [];
        this.isDarkMode = function () {
            if (_this.isNode)
                return false;
            return _this.state === 'dark';
        };
        this.subscribeToColorScheme = function (method) {
            _this.subscribers.push(method);
        };
        this.clearSubscribers = function () {
            _this.subscribers = [];
        };
        this.handleUiChange = function (e) {
            _this.state = e.matches ? 'dark' : 'light';
            if (_this.subscribers.length > 0) {
                _this.subscribers.forEach(function (subscriber) {
                    subscriber(_this.state);
                });
            }
        };
        if (typeof window === 'undefined') {
            this.isNode = true;
            return;
        }
        this.media = window.matchMedia('(prefers-color-scheme: dark)');
        this.media.addListener(this.handleUiChange);
        this.handleUiChange(this.media);
    }
    return DarkModeHandler;
}());
var dm = new DarkModeHandler();
exports["default"] = dm.isDarkMode;
exports.subscribeToColorScheme = dm.subscribeToColorScheme;
